import { Component, Input } from '@angular/core';
import { ReleaseWFSubmittedAdminsRoles } from 'src/app/shared/models/enums.model';
import { ReleaseWFSubmittedAdminsDTO } from 'src/app/shared/models/long-haul.model';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';

@Component({
  selector: 'app-release-wf-submitted-admins',
  templateUrl: './release-wf-submitted-admins.component.html'
})
export class ReleaseWFSubmittedAdminsComponent {
  @Input() public requestId: string = "";
  @Input() public role: string = "";
  @Input() public workflowName: string = "";
  wfSignedAdmins: ReleaseWFSubmittedAdminsDTO[] = [];
  measureItems: ReleaseWFSubmittedAdminsDTO[];
  eunitItems: ReleaseWFSubmittedAdminsDTO[];
  managersItems: ReleaseWFSubmittedAdminsDTO[];

  constructor(private longhaulserv: LongHaulService){

  }

  ngOnInit() {
    this.getReleaseWFSubmittedAdmins();
  }

  getReleaseWFSubmittedAdmins() {
    // Call the service to get the release workflow submitted admins
    this.longhaulserv.getReleaseWFSubmittedAdmins(this.requestId,this.role).subscribe((response: any) => {
      this.wfSignedAdmins = response.Data as ReleaseWFSubmittedAdminsDTO[];
      this.measureItems = this.wfSignedAdmins.filter(item => item.Role === ReleaseWFSubmittedAdminsRoles.MeasurementAdmin);
      this.eunitItems = this.wfSignedAdmins.filter(item => item.Role === ReleaseWFSubmittedAdminsRoles.EunitAdmin);
      this.managersItems = this.wfSignedAdmins.filter(item => item.Role === ReleaseWFSubmittedAdminsRoles.DeputyManager || item.Role === ReleaseWFSubmittedAdminsRoles.Manager);
     });
  }

  getMaxLength(arr1: any[], arr2: any[]): number[] {
    const max = Math.max(arr1.length, arr2.length);
    return Array.from({ length: max }, (_, i) => i);
  }
}
